/**
 * 홈 히어로 한글날 배경 (JCG-3897).
 *
 * 스킨 스위치(`lib/season-skin.ts`)가 hangul 일 때 `HomeHero` 가 렌더하고, 사용자가 스킨을 끄지 않았을 때만
 * (`season:` variant) 보이며 히어로 기본 배경을 덮는다.
 * 세종대왕 감자 뒤로 어좌 병풍인 일월오봉도(해·달·다섯 봉우리)를 두르고, 훈민정음 서문을 흐리게 세로로 적는다.
 * 라이트는 한지, 다크는 밤 바탕이며 아래에 천지인(·ㅡㅣ) 금박 띠를 두른다.
 * 서문 글꼴은 히어로 제목과 같은 Gamja Flower 를 `HomeHero` 에서 받는다.
 */
export default function HangulHeroBackdrop({
  fontClassName,
}: {
  fontClassName: string;
}) {
  return (
    <div
      aria-hidden="true"
      className="pointer-events-none absolute inset-0 hidden overflow-hidden season:block"
    >
      <div className="hangul-paper absolute inset-0" />

      {/* 일월오봉도. 모바일은 마스코트가 없어 글씨를 가리지 않게 옅게 깐다 */}
      <div className="absolute inset-y-0 right-0 w-full opacity-25 sm:w-[46%] sm:opacity-100">
        <div className="hangul-sun absolute left-[10%] top-[16%] h-9 w-9 rounded-full sm:h-11 sm:w-11" />
        <div className="hangul-moon absolute right-[10%] top-[16%] h-9 w-9 rounded-full sm:right-[22%] sm:h-11 sm:w-11" />
        <FivePeaks className="absolute inset-x-0 bottom-1.5 h-[48%] w-full" />
      </div>

      {/* 훈민정음 서문 */}
      <p
        className={`${fontClassName} hangul-preface absolute right-3 top-4 hidden text-sm leading-relaxed tracking-[0.15em] sm:block`}
      >
        나랏말싸미 듕귁에 달아
        <br />
        문자와로 서르 사맛디 아니할쎄
      </p>

      {/* 천지인 금박 띠 */}
      <div className="hangul-band absolute inset-x-0 bottom-0 h-1.5" />
    </div>
  );
}

/** 일월오봉도의 다섯 봉우리와 물결을 단순화한 그림 */
function FivePeaks({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 300 100"
      preserveAspectRatio="none"
      className={className}
      fill="none"
    >
      <path
        d="M0 100V72Q18 58 34 64Q56 32 78 46Q98 58 114 50Q134 10 150 8Q166 10 186 50Q202 58 222 46Q244 32 266 64Q282 58 300 72V100Z"
        className="hangul-peaks"
      />
      {/* 물결 */}
      <path
        d="M0 88q12.5-7 25 0t25 0t25 0t25 0t25 0t25 0t25 0t25 0t25 0t25 0t25 0t25 0V100H0Z"
        className="hangul-waves"
      />
      <path
        d="M0 93q12.5-5 25 0t25 0t25 0t25 0t25 0t25 0t25 0t25 0t25 0t25 0t25 0t25 0"
        className="stroke-white/70 dark:stroke-white/30"
        strokeWidth="1"
        vectorEffect="non-scaling-stroke"
      />
    </svg>
  );
}
